
(function notificationPopupControllerDefinition() {
    'use strict';

    angular.module('NotificationPopup')
        .controller('NotificationPopupController', [
            '$scope', 'config', '$state', 'errorsExtend', 'authExtend', 'storageService', 'auth', 
            function notificationPopupController($scope, config, $state, errors, authExtend, storageService, auth) {
                $scope.acceptFunction = function () {
                    auth.refreshToken();
                    $state.go('inicio');
                };

                
            }
        ]);
})();